module.exports = __webpack_public_path__ + "static/media/scarecrow.07c24c1a.svg";